import { render, staticRenderFns } from "./PropertyReset.vue?vue&type=template&id=ff6527f6&scoped=true&"
import script from "./PropertyReset.vue?vue&type=script&lang=js&"
export * from "./PropertyReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6527f6",
  null
  
)

export default component.exports